module.exports = __webpack_public_path__ + "static/media/nft-15.3a1165f8.png";